// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"4408b667","345":"f06d8bfa","451":"b7fc38bb","547":"4408b667","697":"4408b667"}[chunkId] + ".chunk.css";
};